
<div > 
  @if (plantilla) {
    <div>
      <div [innerHTML]="plantilla"></div>
    </div>
  }
</div>

<div class="mb-3">
  <div class="col d-flex justify-content-center">
    <button class="btn btn-danger btntyc" (click)="salirtyc()">Cambiar datos de tarjeta</button>
  </div>
</div>
